import type { LeadPayload } from "@quiz/quiz-core";
import type { QuizPresentation } from "@quiz/quiz-definitions";

type BookingConfig = NonNullable<QuizPresentation["booking"]>;

export function buildSelfbookingUrl(booking: BookingConfig, payload: Pick<LeadPayload, "lead" | "attribution">): string {
  const url = new URL(booking.url);
  url.searchParams.set("source", booking.source);
  url.searchParams.set("name", payload.lead.name ?? "");
  url.searchParams.set("email", payload.lead.email ?? "");
  url.searchParams.set("phone", payload.lead.phone?.e164 ?? "");
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const) {
    url.searchParams.set(key, payload.attribution[key] ?? "");
  }
  url.searchParams.set("level", booking.level);
  return url.toString();
}
